export const environment = {
    production: process.env.REACT_APP_PRODUCTION_ENV,
    // baseURL: 'https://api-v1.youtoogo.com/api/',
    baseURL: process.env.REACT_APP_BASE_URL,
    // baseURL: 'http://pummaker.api/api/',
    youtooApiKey: 'YOUTOO.BF3A9411DD1C471E125E56EE8157D',
    GmapsApiKey: 'AIzaSyC71e06kid2va5bxRbRnqrcyVEPQffI0IM',
};
